/* eslint-disable sort-keys */
import { darken, rgba } from 'polished';
import Theme from '../types/theme';
import { decrease, increase } from '../colors/chartPalette';
import { designTokens } from '../tokens';
import * as colorPalette from '../colors/defaultPalette';

const colors = {
  accent: colorPalette.orange,
  accentDark: colorPalette.orangeDark,
  accentDarker: colorPalette.orangeDarker,
  accentForeground: colorPalette.black,
  accentLight: colorPalette.orangeLight,
  accentLighter: colorPalette.orangeLighter,

  accentMuted: '#b68435',

  actionDisabled: rgba(colorPalette.neutral500, 0.8),
  actionDisabledBackground: rgba(colorPalette.neutral500, 0.24),
  actionFocus: rgba(colorPalette.neutral500, 0.24),
  actionHover: rgba(colorPalette.neutral500, 0.08),
  actionSelected: rgba(colorPalette.neutral500, 0.16),

  background: colorPalette.white,
  backgroundActive: colorPalette.greyLightest,
  backgroundInactive: colorPalette.greyLighter,

  banner: colorPalette.greyLighter,

  blindMode: 'none',

  border: colorPalette.greyLighter,
  borderDark: 'dimgrey',
  borderLight: colorPalette.greyLightest,
  borderUnified: colorPalette.grey,

  brand: colorPalette.blue,
  brandDark: colorPalette.blueDark,
  brandDarker: colorPalette.blueDarker,
  brandForeground: designTokens.colorPalette.white,
  brandLight: colorPalette.blueLight,
  brandLighter: colorPalette.blueLighter,
  brandMuted: '#008FD9',
  brandUnified: colorPalette.blue,

  buttonPrimary: designTokens.colorPalette.blue700,
  buttonPrimaryBackground: designTokens.colorPalette.blue200,
  buttonPrimaryBackgroundHover: designTokens.colorPalette.blue200,
  buttonPrimaryBackgroundUnified: designTokens.colorPalette.blue200,
  buttonPrimaryBorder: designTokens.colorPalette.blue500,
  buttonPrimaryUnified: designTokens.colorPalette.blue700,

  danger: darken(0.1, colorPalette.red),
  dangerDark: colorPalette.redDark,
  dangerDarker: colorPalette.redDarker,
  dangerForeground: designTokens.colorPalette.white,
  dangerLight: colorPalette.redLight,
  dangerLighter: colorPalette.redLighter,

  dropdownBackground: colorPalette.white,
  dropdownBackgroundActive: colorPalette.greyLightest,

  foreground: colorPalette.greyDarkest,
  foregroundActive: colorPalette.black,
  foregroundInactive: colorPalette.greyDarker,
  foregroundMuted: colorPalette.neutral600,

  information: darken(0.1, colorPalette.blue),

  statistic: {
    negative: darken(0.1, colorPalette.red),
    neutral: colorPalette.greyDarkest,
    positive: darken(0.1, colorPalette.green),
  },

  success: darken(0.1, colorPalette.green),
  successDark: colorPalette.greenDark,
  successDarker: colorPalette.greenDarker,
  successForeground: designTokens.colorPalette.white,
  successLight: colorPalette.greenLight,
  successLighter: colorPalette.greenLighter,

  warning: darken(0.1, colorPalette.yellow),
  warningDark: colorPalette.yellowDark,
  warningDarker: colorPalette.yellowDarker,
  warningForeground: designTokens.colorPalette.white,
  warningLight: colorPalette.yellowLight,

  warningLighter: colorPalette.yellowLighter,
};

const chart = {
  color: {
    accentColor1: 'rgba(212, 219, 231, .3)',
    accentColor2: 'rgba(212, 219, 231, 1)',
    mainColor: 'rgba(44, 51, 63, 1)',
    periods: {
      decrease,
      increase,
    },
    tooltipBackground: 'rgba(255, 255, 255, 1)',
  },
};

const light: Partial<Theme> = {
  chart,
  colors: colors,
  name: 'light',
};

export default light;
